/**
 * Remembers which lens is mounted between visits. localStorage survives
 * refreshes and the offline cache; failures (private browsing, blocked
 * storage) silently fall back to the kit zoom.
 */

import { DEFAULT_LENS, LENS_BY_ID, type Lens } from '@/domain/lens'

const KEY = 'zfc.lens'

export function loadLens(): Lens {
  try {
    const id = localStorage.getItem(KEY)
    return (id && LENS_BY_ID.get(id)) || DEFAULT_LENS
  } catch {
    return DEFAULT_LENS
  }
}

export function saveLens(lens: Lens): void {
  try {
    localStorage.setItem(KEY, lens.id)
  } catch {
    // Storage unavailable — the choice just won't persist.
  }
}
